var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c("ItpFormSelect2", {
        attrs: {
          name: "invoice",
          "bind-object": "",
          placeholder: _vm.messages.searchPlaceholder,
          dataSource: _vm.b_2248226175642056_dataSource,
          valueField: "id",
          textField: "invoice_number",
          clearable: "",
          optionTemplate:
            "<UcSuggestInvoiceOption :option=option></UcSuggestInvoiceOption>",
          selectedOptionTemplate:
            '<UcSuggestInvoiceOption v-if="option.id" :option=option></UcSuggestInvoiceOption>',
          readonly: _vm.editor.isReadonly
        },
        on: {
          optionSelected: function($event) {
            return _vm.evh_2248226175642056_optionSelected($event, {})
          }
        },
        model: {
          value: _vm.editor.invoice,
          callback: function($$v) {
            _vm.$set(_vm.editor, "invoice", $$v)
          },
          expression: "editor.invoice"
        }
      }),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            [
              _vm.editor.invoice &&
              !_vm.editor.invoice.id &&
              _vm.editor.$_resource.invoice &&
              _vm.editor.$_resource.invoice.invoice_number
                ? _c(
                    "ItpBox",
                    [
                      _vm.editor.id
                        ? _c("ItpButton", {
                            attrs: {
                              text: _vm._f("pgettext")(
                                "Create invoice...",
                                "RegisterEntry"
                              ),
                              size: "sm",
                              variant: "light",
                              tooltip: _vm._f("pgettext")(
                                "Record a new invoice.",
                                "RegisterEntry"
                              ),
                              icon: _vm.$config.addIcon
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_5534025912102772_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }